import * as Sentry from '@sentry/vue';

function initializeSentry(Vue, settings) {
    let IS_LOCALHOST = location.hostname.endsWith('zoezidev.se');

    if (!IS_LOCALHOST && !window.__devenv) {
        Sentry.init({
            Vue,
            dsn: 'https://ae2c9a4cb12b4aa69806b9227880be0c@o190554.ingest.us.sentry.io/5437109',
            integrations: window.$zoeziapi.hasFlag('flag-sentry-performance') ? [Sentry.browserTracingIntegration({})] : [],
            environment: settings.environment,
            release: settings.branch || settings.version,
            initialScope: {
                tags: {
                    developer: settings.developer
                }
            },
            ignoreErrors: [
                'TypeError: Failed to fetch',
                'TypeError: NetworkError when attempting to fetch resource.',
                'TypeError: Load failed',
                'ZoeziAPI: Not logged in'
            ],
            tracesSampleRate: window.$zoeziapi.hasFlag('flag-sentry-performance-all') ? 1.0 : 0.05,

            beforeSend(event) {
                // Convert <ZoeziSomeComponent> to zoezi-some-component
                let componentName = event.contexts?.vue?.componentName || '';
                componentName = componentName.replace(/^<|>$/g, '');
                componentName = componentName.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();

                if (componentName == 'anonymous') {
                    return null; // Ignore errors from anonymous components
                }

                if (event.exception?.values[0]?.type == 'NavigationDuplicated') {
                    return null; // Ignore duplicate navigation errors
                }

                return event;
            }
        });
    }
}

export { initializeSentry };
